import PageHeader from "../PageHeader";
import { ReactComponent as LearnerIcon } from "../../images/learnersimage/learnericon.svg";
import useStyles from "../../../styles";
import ReportHeader from "../../CustomComponent/ReportHeader";
import { decryptData } from "../../../crypto";
import { dashboardApi } from "../../../service/services";
import Loader from "../../CustomComponent/Loader";
import { useState } from "react";
import ViewAttendanceReport from "./ViewAttendanceReport";
import axios from "axios";

function AttendanceReport() {
  const classes = useStyles();
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [selectedExam, setSelectedExam] = useState("");
  const [data, setData] = useState([]);

  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const Heading = [
    {
      id: 1,
      pageicon: <LearnerIcon />,
      mainheading: "Attendance Report",
    },
  ];

  const fetchData = async (selectedExam) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/attendance/view/${selectedExam}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setData(response.data.attendance);
      console.log("response course", response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <Loader loaderOpen={loaderOpen} />
      <PageHeader Heading={Heading} />
      <ReportHeader
        exportApi={dashboardApi}
        fetchData={fetchData}
        setLoaderOpen={setLoaderOpen}
        setSelectedExam={setSelectedExam}
        selectedExam={selectedExam}
      />
      <ViewAttendanceReport selectedExam={selectedExam} cources={data} />
    </div>
  );
}
export default AttendanceReport;
